import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Lock, Crown } from 'lucide-react';

export default function PremiumLock({ featureName }) {
  const navigate = useNavigate();

  return (
    <div className="h-full w-full min-h-[400px] flex flex-col items-center justify-center p-8 text-center bg-zinc-900/50 border-2 border-dashed border-zinc-800 rounded-xl">
      <div className="bg-zinc-800 p-6 rounded-full mb-6">
        <Lock className="w-12 h-12 text-zinc-500" />
      </div>
      <h2 className="text-2xl font-bold mb-2 text-white">Unlock {featureName}</h2>
      <p className="text-zinc-400 max-w-md mb-8">
        Upgrade to Monk Mode Pro to access the {featureName} and take your discipline to the next level.
      </p>
      <Button onClick={() => navigate('/upgrade')} className="font-bold btn-glossy">
        <Crown className="w-4 h-4 mr-2" />
        Upgrade to Pro - $4.99/month
      </Button>
    </div>
  );
}
